export default {
  phone: /^[0-9().\-/]+$/,
  phoneChars: /[.\-()]/g,
  latitude: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
  longitude: /^[-+]?((1[0-7]\d|\d?\d)(\.\d+)?|180(\.0+)?)$/,
  credit: /^\d+(\.\d{1,2})?$/,
  partialCredit: /^\d*(\.\d{0,2})?$/,
  imageFile: /\.(png|jpe?g)$/i,
  // keep in sync with getValidUrlRegex() in the API
  url: /^https?:\/\/[^\s/$.?#].[^\s]*$/i,
};